import { render, staticRenderFns } from "./AccountsId.vue?vue&type=template&id=22e83209&scoped=true&"
import script from "./AccountsId.vue?vue&type=script&lang=js&"
export * from "./AccountsId.vue?vue&type=script&lang=js&"
import style0 from "./AccountsId.vue?vue&type=style&index=0&id=22e83209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e83209",
  null
  
)

export default component.exports